import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import React from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';

import './Slider.sass';

interface ISliderProps {
  slides: React.ReactNode[];
  className?: string;
  autoHeight?: boolean;
  navigation?: boolean;
  loop?: boolean;
  autoplay?: boolean;
  text?: boolean;
}
export const Slider: React.FC<ISliderProps> = ({
  slides,
  className = '',
  autoHeight = false,
  navigation = false,
  loop = false,
  autoplay = false,
  text,
}) => {
  const mobileScreen = useMediaQuery('(max-width:900px)');
  return (
    <div>
      <Swiper
        modules={[Pagination, Navigation, Autoplay]}
        spaceBetween={10}
        pagination={
          mobileScreen
            ? {
                el: '.my-custom-pagination-div',
                clickable: true,
                renderBullet: (index, className) => {
                  return '<span class="' + className + '"></span>';
                },
              }
            : true
        }
        className={classNames('slider ', className, {
          ['mobile']: mobileScreen,
        })}
        navigation={navigation}
        autoHeight={autoHeight}
        loop={loop}
        autoplay={
          autoplay && {
            delay: 5000,
            disableOnInteraction: false,
          }
        }
      >
        {slides.map((slide, index) => (
          <SwiperSlide className="slider__slide" key={index}>
            {slide}
            {text && index === 0 && <p>Выбор экспертов! Рекомендуем надежные инструменты и оборудование</p>}
          </SwiperSlide>
        ))}
        <div className="my-custom-pagination-div" />
      </Swiper>
    </div>
  );
};
